/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgTrace = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 62 52",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.418.758a5 5 0 0 0-5 5v7.461a5 5 0 0 0 5 5H29v7.537H10a5 5 0 0 0-5 5v6.784a6.992 6.992 0 1 0 4 .001v-6.785a1 1 0 0 1 1-1h19v7.792a6.992 6.992 0 1 0 4 0v-7.792h19a1 1 0 0 1 1 1v6.781a6.992 6.992 0 1 0 4-.001v-6.78a5 5 0 0 0-5-5H33v-7.537h12.582a5 5 0 0 0 5-5V5.758a5 5 0 0 0-5-5H16.418Zm-1 5a1 1 0 0 1 1-1h29.164a1 1 0 0 1 1 1v7.461a1 1 0 0 1-1 1H16.418a1 1 0 0 1-1-1V5.758Zm-8.42 41.477a2.992 2.992 0 1 0 0-5.985 2.992 2.992 0 0 0 0 5.985Zm50.996-2.996a2.992 2.992 0 1 1-5.984 0 2.992 2.992 0 0 1 5.984 0ZM31 47.242a2.992 2.992 0 1 0 0-5.984 2.992 2.992 0 0 0 0 5.984Z",
  clipRule: "evenodd"
}));

export default SvgTrace;